import React from 'react';
import Helmet from 'react-helmet';
import filter from 'lodash/filter';
import omitBy from 'lodash/omitBy';

const scripts = [
  {
    _name: 'Google Tag Manager Dev',
    _env: ['development'],
    type: 'text/javascript',
    innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NN7GCJH');`,
  },
  {
    _name: 'Google Tag Manager Prod',
    _env: ['production'],
    type: 'text/javascript',
    innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-TMFMVX');`,
  },
];

export default () => {
  const env = process.env.REACT_APP_ENV || 'development';
  const scriptsByEnv = filter(scripts, { _env: [env] });
  const sanitizedScripts = scriptsByEnv.map(script => {
    return omitBy(script, (val, key) => key[0] === '_');
  });
  return <Helmet script={sanitizedScripts} />;
};
